import { useNativeFeatures } from './useNativeFeatures';

type HapticPattern = 'light' | 'medium' | 'heavy' | 'success' | 'error' | 'warning';

const HAPTIC_PATTERNS: Record<HapticPattern, number | number[]> = {
  light: 10,
  medium: 25,
  heavy: 50,
  success: [10, 50, 10],
  error: [50, 100, 50],
  warning: [25, 50, 25],
};

export const useHapticFeedback = () => {
  const { vibrate, supportedFeatures } = useNativeFeatures();

  const triggerHaptic = (pattern: HapticPattern = 'medium') => {
    if (!supportedFeatures.haptics) return false;
    
    const hapticPattern = HAPTIC_PATTERNS[pattern];
    return vibrate(hapticPattern);
  };

  return {
    triggerHaptic,
    isSupported: supportedFeatures.haptics,
  };
};
